import { useGetProjectsQuery } from '@/slices/projectSlice';

const useQuotes = ({ _customer, skip } = { _customer: '', skip: false }) => {
	const { quotes, isLoading, isError } = useGetProjectsQuery(undefined, {
		skip,
		selectFromResult: ({ data, isLoading, isError }) => {
			const quotes = data?.ids
				?.map((id) => data.entities[id]) // Map ids to project objects
				.filter((project) => project.quote) // Filter projects with a quote
				.filter((project) => {
					if (!_customer) return true;

					return project._customer === _customer;
				}) // Filter by customer if _customer is passed
				.map((project) => {
					return {
						...project.quote,
						number: project.number,
						customer: project.customer,
						_project: project._id,
						type: 'quote',
					};
				}); // Extract quotes
			return { quotes, isLoading, isError };
		},
	});

	return { quotes, isLoading, isError };
};

export default useQuotes;
